import { MarketingWrapper } from './FraudDefenseMarketing.styles'
import { HeroSection } from './HeroSection'
import { IntegrationSection } from './IntegrationSection'
import { FooterSection } from './FooterSection'

const FraudDefenseMarketing = () => {
    return (
        <MarketingWrapper>
            <HeroSection />
            <IntegrationSection />
            <FooterSection />
        </MarketingWrapper>
    )
}

export default FraudDefenseMarketing
